import React from 'react'
import "./Modal.scss"
import Button from '../../../../partials/Button'

function Modal({show = false,
                   size='extralarge' ,
                   caption = '',
                   content,
                   showContinue = false,
                   continueCaption,
                   onContinueClick,
                   leftActionButtonCaption = "",
                   onLeftActionButtonClick = () => {},
                   children
               }) {
    if (show === false) {
        return null
    }
    return  <div className='Modal' >
                <div className="modal_container">
                <div className={`modal_content ${size}`}>
                    {content}
                    {children || <></>}
                    {showContinue && <div className="modal_actions">
                        {leftActionButtonCaption !== "" &&
                        <Button text={leftActionButtonCaption} variant="toRight"
                             onClick={onLeftActionButtonClick}/>
                            
                       
                        }
                        <Button text={continueCaption || 'CLOSE'} variant="toRight"
                              onClick={() => {
                            if (onContinueClick) {
                                onContinueClick()
                            }
                        }}/>
                        </div>}
                </div>
            </div>
    </div>
}

export default Modal;
